import React, { useState } from 'react';
import cc_format from '../../func/card_formatter';

const TextField = ({
	placeholder,
	error,
	name,
	type,
	width,
	value,
	margin,
	handleChange,
	icon,
	max,
	min,
	comment,
	autoComplete,
}) => {
	const [isFocused, setIsFocused] = useState(false);
	const [isVisible, setIsVisible] = useState(false);

	return (
		<div
			className="input-container"
			style={{
				width: width == 'full' ? '100%' : `calc(${width == 'half' ? 50 : width}% - 6px)`,
				marginRight: margin ? '12px' : '0px',
				backgroundColor: 'transparent',
			}}
		>
			<div className={`input input--text ${error && 'input--error'}`}>
				<input
					maxLength={max}
					max={max}
					min={min}
					className="styledInput"
					autoComplete={autoComplete}
					type={type}
					name={name}
					value={value}
					onFocus={() => {
						setIsFocused(true);
					}}
					onChange={(name) => {
						handleChange(name);
					}}
					onBlur={() => {
						setIsFocused(false);
					}}
				/>
				<label className={isFocused || value.length > 0 ? 'styledLabel styledLabel--active' : 'styledLabel'}>
					{placeholder}
				</label>

				{icon && (
					<div
						className="input__img"
						onClick={() => {
							if (window.isMobile) {
								setIsVisible(!isVisible);
							}
						}}
						style={{
							backgroundImage: `url(${icon}`,
						}}
					>
						{comment && (
							<span className="input__comment" visible={isVisible.toString()}>
								{comment}
							</span>
						)}
					</div>
				)}
			</div>
			{error && <span className="formError">{error}</span>}
		</div>
	);
};

export default TextField;
